import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IAuthData } from '@/types/auth';

export interface AuthState {
  userData: IAuthData | null;
  isAuthenticated: boolean;
  hydrated: boolean;
}

const initialState: AuthState = {
  userData: null,
  isAuthenticated: false,
  hydrated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    hydrateAuth: (state, action: PayloadAction<IAuthData | null>) => {
      state.userData = action.payload;
      state.isAuthenticated = Boolean(action.payload?.accessToken);
      state.hydrated = true;
    },
    signInSuccess: (state, action: PayloadAction<IAuthData>) => {
      state.userData = action.payload;
      state.isAuthenticated = true;
      state.hydrated = true;
    },
    signOut: () => ({ ...initialState, hydrated: true }),
  },
});

export const { hydrateAuth, signInSuccess, signOut } = authSlice.actions;
export default authSlice.reducer;
